import { Portal, PortalHost } from '@gorhom/portal';
import React from 'react';
import { View } from 'react-native';

const fixedPositionPortalName = 'fixed-position-portal';
const notificationPortalHost = 'notification-portal';

export const FixedPositionPortalContainer: React.FC<{ children: any }> = (props) => (
    <View style={{ width: '100%', height: '100%', position: 'relative' }} testID="fixed-position-container">
        <View style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, width: '100%', height: '100%' }}>
            {props.children}
        </View>
        <PortalHost name={fixedPositionPortalName} />
        <PortalHost name={notificationPortalHost} />
    </View>
);

export const FixedContentContainer: React.FC<{ children: any }> = ({ children }) => {
    return <Portal hostName={fixedPositionPortalName}>{children}</Portal>;
};

export const NotificationPortalContainer: React.FC<{ children: any }> = ({ children }) => {
    return <Portal hostName={notificationPortalHost}>{children}</Portal>;
};
